import client from './client';

export interface QuickOrderPayload {
    product_id: number;
    name: string;
    phone: string;
    city: string;
    address: string;
    qty: number;
    product_variant_id?: number;
}

export const submitQuickOrder = async (data: QuickOrderPayload) => {
    const response = await client.post('/orders/quick', data);
    return response.data;
};

export const submitOrder = async (data: any) => {
    const response = await client.post('/orders', data);
    return response.data;
};

export const submitContact = async (data: any) => {
    const response = await client.post('/contact', data);
    return response.data;
};
